import config from './icons-library-config.json';

export const iconsLibraryCacheName = 'mapa-cache';
export const iconsLibraryCacheURL = `/icons-library/${config.icons}`;
export const iconsLibraryCategoriesCacheURL = `/icons-library/${config.categories}`;
